import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../../constants/whatsapp";

export default function WhatsAppButton({
  label = "Chat with us",
  mobileLabel,
  size = "default",
  compact = false,
  variant = "green",
  rounded = "full",
  className = "",
}) {
  const colorClasses =
    variant === "teal"
      ? "bg-[#14B48C] hover:bg-[#11997A]"
      : "bg-[#25D366] hover:bg-[#20bd5a]";

  const roundingClass =
    rounded === "md" ? "rounded-[6px]" : "rounded-full";

  const displayLabel = mobileLabel ? (
    <>
      <span className="sm:hidden">{mobileLabel}</span>
      <span className="hidden sm:inline">{label}</span>
    </>
  ) : (
    label
  );

  const sizeClasses =
    size === "large"
      ? "min-h-[48px] sm:min-h-[56px] px-5 sm:px-8 py-3 sm:py-4 text-sm sm:text-lg max-w-full"
      : "px-4 sm:px-5 py-2.5 text-sm";

  if (compact) {
    return (
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center justify-center ${roundingClass} ${colorClasses} text-white transition-colors p-2.5 shrink-0 ${className}`}
        aria-label={label}
      >
        <MessageCircle className="w-5 h-5" aria-hidden />
      </a>
    );
  }

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 ${roundingClass} ${colorClasses} text-white font-medium transition-colors text-center ${sizeClasses} ${className}`}
    >
      <MessageCircle className="w-5 h-5 shrink-0" aria-hidden />
      <span className="leading-snug">{displayLabel}</span>
    </a>
  );
}
